import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "../../../../components/ui/Button";
import { getWaypointById } from "../../../../api";
import TitleSubtitle from "../../../../components/common/TitleSubtitle";
import TextInput from "../../../../components/ui/TextInput";
import Icon from "../../../../components/common/Icon";
import { WaypointTitleProps, RouteParams } from "../../../../types/screensTypes";
import { idToLanguage } from "../../../../utils/idtolanguage";
import { useGlobalState } from "../../../../context/useGlobalState";
import { useWaypointChangeDetection } from "../../../../hooks/useWaypointChangeDetection";
import stepStyles from "../createStep.module.css";
import wp from "./WaypointEdit.module.css";

const WaypointTitle: React.FC<WaypointTitleProps> = ({ navigateToNext }) => {
    const { wptId, language } = useParams<RouteParams>();
    const { t: rawT } = useTranslation();
    const t = rawT as any;
    const { data } = useGlobalState();

    const {
        value: title,
        setValue: setTitle,
        saveIfChanged,
        setOriginalValue,
    } = useWaypointChangeDetection<string>({
        wptId: wptId || "",
        language,
        initialValue: "",
    });

    const getWaypoint = async (id: string): Promise<void> => {
        const token = localStorage.getItem("token");
        if (!token || !language) return;
        const waypointData = await getWaypointById({ token, id, language });

        let loadedTitle = "";

        if (waypointData) {
            const waypointArray = waypointData;
            if (
                waypointArray &&
                waypointArray.waypointTemporary &&
                waypointArray.waypointTemporary.TemporaryWaypointLocalized &&
                waypointArray.waypointTemporary.TemporaryWaypointLocalized.length > 0
            ) {
                const name = waypointArray.waypointTemporary.TemporaryWaypointLocalized[0].title;
                if (!name) {
                    const fetchedWaypoint = waypointArray.waypoint;
                    if (
                        fetchedWaypoint &&
                        fetchedWaypoint.waypointLocalized &&
                        fetchedWaypoint.waypointLocalized.length > 0
                    ) {
                        loadedTitle = fetchedWaypoint.waypointLocalized[0].name || "";
                    }
                } else {
                    loadedTitle = name;
                }
            } else {
                const fetchedWaypoint = waypointArray.waypoint;
                if (
                    fetchedWaypoint &&
                    fetchedWaypoint.waypointLocalized &&
                    fetchedWaypoint.waypointLocalized.length > 0
                ) {
                    loadedTitle = fetchedWaypoint.waypointLocalized[0].name || "";
                }
            }
        }

        setTitle(loadedTitle);
        setOriginalValue(loadedTitle);
    };

    const saveWaypoint = async (): Promise<void> => {
        if (!wptId || !language) return;
        await saveIfChanged({ title });
        navigateToNext(wptId, language);
    };

    useEffect(() => {
        if (wptId && wptId !== "") {
            getWaypoint(wptId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [wptId, language]);

    return (
        <div className={`${stepStyles.editScreen} ${wp.screen}`}>
            <TitleSubtitle
                title={t("customerFacingTitleOfYourStory") + idToLanguage(language || "", data?.languagesAI, t)}
                subtitle={""}
                layout="edit"
            />
            <div className={wp.nameField}>
                <TextInput
                    placeholder={t("title")}
                    value={title}
                    size="small"
                    onChange={(e) => setTitle(e.target.value)}
                />
                <Icon name="ic-list" className={wp.nameIcon} />
            </div>

            <div className={`${stepStyles.stepButton} ${stepStyles.footer}`}>
                <Button
                    variant="primary"
                    shape="pill"
                    className={stepStyles.continueBtn}
                    label={t("continue")}
                    onClick={saveWaypoint}
                />
            </div>
        </div>
    );
};

export default WaypointTitle;
